import {
    EXPORT_CSV_ALERTS,
    EXPORT_CSV_ALERTS_SUCCESS,
    EXPORT_CSV_ALERTS_FAIL
} from './actionTypes';

export const exportCsvAlerts = params => ({
    type: EXPORT_CSV_ALERTS,
    payload: params
});

export const exportCsvAlertsSuccess = response => ({
    type: EXPORT_CSV_ALERTS_SUCCESS
});

export const exportCsvAlertsFail = error => ({
    type: EXPORT_CSV_ALERTS_FAIL,
    payload: error
});
